import * as z from "zod";
import { discountConfiguration, redoDiscountSchema } from "./discount-schemas";

export const createDiscount = {
  name: "createDiscount" as const,
  input: z.object({ discountConfiguration }),
  output: redoDiscountSchema,
};
